import { DropdownOptionType } from '@Components/Dropdown/Type';
import { postFedExDetails } from '@Reducers/AdminShipment/actions';
import { AppDispatch } from '@Store';
import * as Yup from 'yup';

export const ApiServiceCodeOptions: DropdownOptionType[] = [
  { value: 'A2', display: 'A2' },
  { value: 'ARAMEX_DEFFERED', display: 'Aramex Deffered' },
  { value: 'ARAMEX_GPX', display: 'Aramex GPX' },
  { value: 'D1', display: 'D1' },
  { value: 'FEDEX IP SPECIAL', display: 'Fedex IP Special' },
  { value: 'FEDEX PRIORITY', display: 'Fedex Priority' },
  { value: 'FEDEX_SMALL', display: 'Fedex Small' },
  { value: 'FEDEXIP_UC', display: 'Fedex IP UC' },
  { value: 'SELF', display: 'Self' },
  { value: 'UC_UPS', display: 'UC UPS' },
];

export const ProductCodeOptions: DropdownOptionType[] = [
  { value: 'PAK', display: 'PAK' },
  { value: 'NONDOX', display: 'Non-Dox' },
];

export const TermsOfTradeOptions: DropdownOptionType[] = [{ value: 'FOB', display: 'FOB' }];

export const universalInformationSchema = Yup.object().shape({
  type: Yup.string().trim().required('Type is required'),
  accountNo: Yup.string().trim().required('Account is required'),
  apiServiceCode: Yup.string().trim().required('API Service Code is required'),
  productCode: Yup.string().trim().required('Product Code is required'),
  termsOfTrade: Yup.string().trim().required('Terms of Trade is required'),
});

export interface UniversalInformation {
  accountNo: string;
  apiServiceCode: string;
  productCode: string;
  termsOfTrade: string;
  type: string;
  freeFormCurrency?: number;
  newDocketFreeFormInvoice?: string;
  awbShowToUser: boolean;
}

export const onForward = ({
  values,
  shipmentNumber,
  dispatch,
  nextFunc,
}: {
  values: UniversalInformation;
  shipmentNumber: string;
  dispatch: AppDispatch;
  nextFunc: () => void;
}) => {
  const body = { ...JSON.parse(JSON.stringify(values)) };
  body.csp = 'universal';
  for (const key in body) {
    if (body[key]) {
      if (key === 'accountNo') {
        if (Array.isArray(body[key])) {
          body[key] = body[key][0]?.value?.split('-')?.[0] || '';
        } else if (typeof body[key] === 'object' && body[key]?.value) {
          body[key] = body[key].value.split('-')?.[0] || '';
        } else if (typeof body[key] === 'string') {
          body[key] = body[key].split('-')?.[0];
        }
      }
    }
  }

  dispatch(
    postFedExDetails({
      shipmentNumber: `${shipmentNumber}`,
      body,
      date: null,
      nextFunc,
    }),
  );
};
